jQuery(document).ready(function ($) {
  function addEventButtons() {
    // Target list view event wrappers
    $('.tribe-events-calendar-list__event-wrapper').each(function () {
      var $event = $(this);

      // Look for the link inside the title heading (handles both standard a-tags and V2 specific title classes)
      var $titleLink = $event.find('h3[class*="__event-title"] a, .tribe-events-calendar-list__event-title-link, h3 a').first();
      var eventLink = $titleLink.attr('href');

      // Target the description / excerpt container
      var $description = $event.find('.tribe-events-calendar-list__event-description');

      // Append only if the link exists, description container exists, and wrapper hasn't been added yet
      if (eventLink && $description.length && !$event.find('.flip-slider').length) {
        var $button = $('<a>', {
          'href': eventLink,
          'class': 'button',
          'text': 'More Information'
        });

        var $wrapper = $('<div>', {
          'class': 'flip-slider'
        }).append($button);

        $description.append($wrapper);
      }
    });
  }

  // Run on initial load
  addEventButtons();

  // The Events Calendar V2 Custom Event Listeners
  $(document).on('afterSetup.tribeEvents ajaxSuccess.tribeEvents tribe_events_after_load_events', function () {
    addEventButtons();
  });

  // Fallback for generic jQuery AJAX requests or older V1 plugin versions
  $(document).ajaxComplete(function (event, xhr, settings) {
    if (settings && settings.data && typeof settings.data === 'string' && settings.data.indexOf('tribe') !== -1) {
      addEventButtons();
    }
  });
});

jQuery(document).ready(function ($) {
  function moveEventPrice() {
    // Loop through each event item in the list view
    $('.tribe-events-calendar-list__event-wrapper').each(function () {
      var $event = $(this);

      // Target the price element (covers both V1 and V2 container classes)
      var $price = $event.find('.tribe-events-calendar-list__event-price, .tribe-common-b2--bold, .tribe-events-event-cost, .tribe-events-calendar-list__event-cost');

      // Target the description container
      var $description = $event.find('.tribe-events-calendar-list__event-description');

      // Only move if both elements exist and the price isn't already directly before the description
      if ($price.length && $description.length && !$description.prev().is($price)) {
        // .insertBefore() detaches the element from its old home and drops it cleanly above the description
        $price.insertBefore($description);
      }
    });
  }

  // Run on initial page load
  moveEventPrice();

  // Re-run whenever The Events Calendar finishes updating via AJAX
  $(document).on('afterSetup.tribeEvents ajaxSuccess.tribeEvents tribe_events_after_load_events', function () {
    moveEventPrice();
  });

  // Fallback for general AJAX or older legacy templates
  $(document).ajaxComplete(function (event, xhr, settings) {
    if (settings && settings.data && typeof settings.data === 'string' && settings.data.indexOf('tribe') !== -1) {
      moveEventPrice();
    }
  });
});
